import { render, staticRenderFns } from "./data_pegawai.vue?vue&type=template&id=2ab3d5f0&"
import script from "./data_pegawai.vue?vue&type=script&lang=js&"
export * from "./data_pegawai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports